import { useContext } from 'react';
import { cartContext } from '../contexts/CartContext';

export function useCart() {
  const value = useContext(cartContext);
  return value;
}
